<template lang="pug">
  .search-switcher
    lei-popover(:text="tooltips.searchExpert", placement="bottom")
      el-switch(
      :active-text="activeText",
      :active-color="successColor",
      :inactive-color="defaultColorLight1",
      :value="expertMode",
      @change="changeMode(expertMode)")
</template>
<script>
import { successColor, defaultColorLight1, } from '../../constants/colors'
import { mapMutations, mapState, } from 'vuex'
import {
  CHANGE_MODE,
  RESET_CRITERIA,
  RESET_SIMPLE_FILTERS,
} from '../../store/modules/search/mutations-types'
import LeiPopover from '../lei-components/LeiPopover'
import simple from '../../constants/tooltips/simple'
import RouterSearch from '../../mixins/router-search-mixin'

export default {
  components: { LeiPopover, },
  mixins: [ RouterSearch, ],
  props: {
    activeText: {
      type: String,
      default: 'Expert Mode',
    },
  },
  data () {
    return {
      successColor,
      defaultColorLight1,
      tooltips: simple,
    }
  },
  computed: {
    ...mapState('search', [ 'expertMode', ]),
  },
  methods: {
    changeMode (value) {
      this.resetExpert()
      this.resetSimple()
      this.change(value)
      this.routerSearch()
    },

    ...mapMutations('search', {
      change: CHANGE_MODE,
      resetExpert: RESET_CRITERIA,
      resetSimple: RESET_SIMPLE_FILTERS,
    }),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"

  .search-switcher
    .el-switch__label, .el-switch__label.is-active
      color $default-color
      font-weight 600
      font-size 0.8rem

  @media (max-width: $tablet)
    .search-switcher
      margin-bottom 15px
</style>



// WEBPACK FOOTER //
// src/components/search-components/SearchSwitcher.vue